import request from '@pulse/utils/request';

export default class ApiBase {
  public baseUrl: string;
  private version: string;

  constructor(apiBaseUrl: string, version: string = 'v1') {
    this.baseUrl = apiBaseUrl;
    this.version = version;
    this.ensureVersion();
  }

  /**
   * Ensures the baseUrl has the specified version prefix
   * Handles cases where apiBaseUrl may or may not already include the version
   *
   * - Valet includes v1 in the baseUrl
   * - Concierge doesn't include v1 in the baseUrl
   */
  private ensureVersion(): void {
    if (!this.baseUrl || this.baseUrl.trim().length === 0) {
      throw new Error('Missing value for apiBaseUrl');
    }

    const versionPath = `/${this.version}`;
    if (!this.baseUrl.includes(versionPath)) {
      this.baseUrl = `${this.baseUrl}${versionPath}`;
    }
  }

  get client() {
    return request.create({
      baseURL: this.baseUrl,
    });
  }
}
